import React from 'react'
import { Stack, Box } from '@mui/material'
import useWindowDimensions from '@hooks/useWindowDimensions'
import SidebarNavigation from '@components/SidebarNavigation'
import { useDevMode } from '@plug-core/state'
import plugMaskot from '@assets/icons/plug-maskot.png'

const DESKTOP_BREAKPOINT = 768 // pixels

interface ResponsiveLayoutProps {
  children: React.ReactNode
  showBottomNavigation?: boolean // Allow parent to control bottom nav visibility
}

const ResponsiveLayout: React.FC<ResponsiveLayoutProps> = ({
  children,
  showBottomNavigation = true,
}) => {
  const { width } = useWindowDimensions()
  const { devEnabled } = useDevMode()
  const isDesktop = width >= DESKTOP_BREAKPOINT

  if (isDesktop) {
    // Desktop layout: Sidebar + Main content
    return (
      <Box position="relative" height="100%">
        {/* Blurred background maskot */}
        <Box
          position="absolute"
          top="5%"
          sx={{
            transform: 'translate(20%, 20%)',
            width: '400px',
            height: '400px',
            backgroundImage: `url(${plugMaskot})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            filter: 'blur(20px)',
            opacity: 0.1,
            zIndex: 0,
            pointerEvents: 'none',
          }}
        />
        <Stack direction="row" height="100%" position="relative" zIndex={1}>
          <SidebarNavigation />
          <Stack
            flex={1}
            ml="max(240px, calc((100vw - 600px) / 2))" // Dynamic left margin, minimum 240px sidebar
            height={`calc(100% - ${devEnabled ? 40 : 0}px)`}
            overflow="hidden"
            alignItems="flex-start"
          >
            <Stack maxWidth="600px" width="100%" height="100%">
              {children}
            </Stack>
          </Stack>
        </Stack>
      </Box>
    )
  }

  // Mobile layout: Full width content (bottom nav handled by parent)
  return (
    <Stack height={`calc(100% - ${devEnabled ? 40 : 0}px)`}>
      {children}
    </Stack>
  )
}

export default ResponsiveLayout
